<template>
  <div class="roi-page">
    <div class="filter-bar">
      <div class="filter-row">
        <span class="filter-label">平台名称</span>
        <el-select v-model="searchForm.platformName" placeholder="请选择平台" clearable class="filter-select">
          <el-option label="百度" value="百度" />
          <el-option label="搜狗" value="搜狗" />
          <el-option label="360" value="360" />
          <el-option label="百度国际" value="百度国际" />
          <el-option label="信息流" value="信息流" />
        </el-select>
        <span class="filter-label">用户名</span>
        <el-input
          v-model="searchForm.username"
          placeholder="请输入用户名"
          clearable
          maxlength="100"
          show-word-limit
          class="filter-input"
        />
        <span class="filter-label">是否停用</span>
        <el-select v-model="searchForm.disabled" placeholder="请选择" clearable class="filter-select">
          <el-option label="未停用" :value="false" />
          <el-option label="已停用" :value="true" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery" :loading="queryLoading">查询</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button icon="el-icon-plus" @click="handleAdd">新增账户</el-button>
      </div>
    </div>
    <el-card shadow="never" class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        size="small"
        v-loading="loading"
        class="promotion-account-table"
      >
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="platformName" label="平台名称" width="100" show-overflow-tooltip />
        <el-table-column prop="username" label="用户名" min-width="120" show-overflow-tooltip />
        <el-table-column prop="accountRemark" label="账户备注" min-width="120" show-overflow-tooltip />
        <el-table-column prop="addDate" label="添加日期" width="100" align="center" />
        <el-table-column prop="disabled" label="是否停用" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.disabled ? 'danger' : 'success'" size="small">
              {{ row.disabled ? '已停用' : '未停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="disabledDate" label="停用日期" width="100" align="center" />
        <el-table-column prop="disabledReason" label="停用原因" width="100" show-overflow-tooltip />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleDetail(row)">详情</el-button>
            <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button
              v-if="canDeletePromotionAccount"
              type="text"
              size="small"
              class="danger-text-btn"
              @click="handleDelete(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="addDialogVisible" width="1000px" :close-on-click-modal="false" @close="resetForm">
      <el-form v-if="isDetail" :model="detailForm" label-width="120px">
        <el-form-item label="授权信息明细">
          <div class="authorization-info-kv">
            <div v-if="parsedAuthorizationInfoRows.length === 0" class="authorization-info-empty">暂无授权信息</div>
            <div
              v-for="item in parsedAuthorizationInfoRows"
              :key="item.key"
              class="authorization-info-row"
            >
              <div class="authorization-info-key">{{ item.key }}</div>
              <div class="authorization-info-value">
                <span class="authorization-info-text">{{ item.value }}</span>
                <el-button
                  v-if="item.copyable"
                  type="text"
                  size="small"
                  icon="el-icon-document-copy"
                  @click="copyAuthorizationValue(item.value, item.key)"
                >复制</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="授权信息">
          <el-input
            v-model="detailForm.thirdPartyAuthorizationInfo"
            type="textarea"
            :rows="12"
            readonly
            placeholder="暂无授权信息"
            style="width: 100%;"
          />
        </el-form-item>
      </el-form>
      <el-form v-else ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="平台名称" prop="platformName">
              <el-radio-group v-model="addForm.platformName">
                <el-radio label="百度">百度</el-radio>
                <el-radio label="搜狗">搜狗</el-radio>
                <el-radio label="360">360</el-radio>
                <el-radio label="百度国际">百度国际</el-radio>
                <el-radio label="信息流">信息流</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账户主体" prop="entityCompany">
              <el-input v-model="addForm.entityCompany" placeholder="请输入账户主体" maxlength="100" show-word-limit clearable style="width: 350px;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="appId" prop="appId">
              <el-input v-model="addForm.appId" placeholder="请输入appId" maxlength="200" show-word-limit clearable style="width: 350px;" />
            </el-form-item>
            
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账户名称" prop="username">
              <el-input v-model="addForm.username" placeholder="请输入账户名称" maxlength="100" show-word-limit clearable style="width: 350px;" />
            </el-form-item>
            
          </el-col>
          <el-col :span="12">
            <el-form-item label="账户密码" prop="password">
              <el-input v-model="addForm.password" type="password" :placeholder="isEdit ? '不修改请留空' : '请输入账户密码'" maxlength="100" show-word-limit show-password clearable style="width: 350px;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="secretKey" prop="secretKey">
              <el-input v-model="addForm.secretKey" placeholder="请输入secretKey" maxlength="200" show-word-limit clearable style="width: 350px;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="token" prop="token">
              <el-input v-model="addForm.token" placeholder="请输入token" maxlength="100" show-word-limit clearable style="width: 350px;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isEdit" :gutter="20">
          <el-col v-if="isEdit" :span="12">
            <el-form-item label="是否停用" prop="disabled">
              <el-select v-model="addForm.disabled" placeholder="请选择" clearable style="width: 350px;">
                <el-option label="未停用" :value="false" />
                <el-option label="已停用" :value="true" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isEdit && addForm.disabled" :gutter="20">
          <el-col :span="12">
            <el-form-item label="停用日期" prop="disabledDate" required>
              <el-date-picker
                v-model="addForm.disabledDate"
                type="datetime"
                placeholder="请选择停用日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 350px;"
                :picker-options="{ firstDayOfWeek: 1 }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="停用原因" prop="disabledReason" required>
              <el-input v-model="addForm.disabledReason" placeholder="请输入停用原因" maxlength="300" show-word-limit clearable style="width: 350px;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="accessToken" prop="accessToken">
              <el-input v-model="addForm.accessToken" type="textarea" :rows="4" readonly placeholder="授权成功后自动生成" maxlength="500" show-word-limit style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="授权链接" prop="authorizationLink" class="copyright_link_box">
              <el-input v-model="addForm.authorizationLink" type="textarea" :rows="3" placeholder="请输入授权链接" maxlength="500" show-word-limit clearable style="width: calc(100% - 100px);" />
              <el-button style="width:90px;margin-left:10px;" @click="openAuthorizationLink()" type="primary">去授权</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="账户备注" prop="accountRemark">
              <el-input v-model="addForm.accountRemark" type="textarea" :rows="3" placeholder="请输入账户备注" maxlength="1000" show-word-limit clearable style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">{{ isDetail ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!isDetail" type="primary" @click="handleFormSubmit" :loading="addSubmitLoading">确定</el-button>
      </span>
    </el-dialog>

    <div class="pagination-wrapper">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { getUserRole, getRoleCode, getAccount } from '@/utils/sessionAuth';

export default {
  name: 'ROI',
  data() {
    return {
      loading: false,
      queryLoading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        platformName: '',
        username: '',
        disabled: null
      },
      addDialogVisible: false,
      addSubmitLoading: false,
      isEdit: false,
      isDetail: false,
      editingId: null,
      detailForm: {
        thirdPartyAuthorizationInfo: ''
      },
      addForm: {
        username: '',
        password: '',
        token: '',
        authorizationLink: '',
        accessToken: '',
        appId: '',
        secretKey: '',
        platformName: '百度',
        entityCompany: '',
        disabled: false,
        disabledDate: '',
        disabledReason: '',
        accountRemark: ''
      },
      addFormRules: {
        username: [{ required: true, message: '请输入账户名称', trigger: ['blur', 'change'] }],
        password: [
          { required: true, message: '请输入账户密码', trigger: ['blur', 'change'], validator: (rule, value, cb) => {
            if (this.isEdit) return cb();
            if (!value || !String(value).trim()) return cb(new Error('请输入账户密码'));
            cb();
          } }
        ],
        platformName: [{ required: true, message: '请选择平台名称', trigger: ['blur', 'change'] }],
        entityCompany: [
          { required: true, message: '请输入账户主体', trigger: ['blur', 'change'] },
          { max: 100, message: '最多100字', trigger: ['blur', 'change'] }
        ],
        appId: [{ required: true, message: '请输入appId', trigger: ['blur', 'change'] }],
        secretKey: [{ required: true, message: '请输入secretKey', trigger: ['blur', 'change'] }],
        disabledDate: [{
          validator: (rule, value, cb) => {
            if (!this.isEdit || !this.addForm.disabled) return cb();
            if (!value || !String(value).trim()) return cb(new Error('请选择停用日期'));
            cb();
          },
          trigger: ['blur', 'change']
        }],
        disabledReason: [{
          validator: (rule, value, cb) => {
            if (!this.isEdit || !this.addForm.disabled) return cb();
            if (!value || !String(value).trim()) return cb(new Error('请输入停用原因'));
            if (String(value).trim().length > 300) return cb(new Error('停用原因最多300字'));
            cb();
          },
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: {
    dialogTitle() {
      if (this.isDetail) return '账户详情';
      return this.isEdit ? '编辑账户' : '新增账户';
    },
    parsedAuthorizationInfoRows() {
      const text = this.detailForm.thirdPartyAuthorizationInfo ? String(this.detailForm.thirdPartyAuthorizationInfo).trim() : '';
      if (!text) return [];
      let data = null;
      try {
        data = JSON.parse(text);
      } catch (e) {
        return [];
      }
      if (!data || typeof data !== 'object' || Array.isArray(data)) return [];
      return Object.keys(data).map(key => {
        const isDuration = key === 'expiresIn' || key === 'refreshExpiresIn';
        const value = isDuration ? this.formatDurationSeconds(data[key]) : this.formatAuthorizationValue(data[key]);
        return {
          key,
          value,
          copyable: key === 'accessToken' || key === 'refreshToken'
        };
      });
    },
    /** 与后台删除接口一致：仅超级管理员（admin）与系统管理员（SYSTEM_ADMIN） */
    canDeletePromotionAccount() {
      const rc = (getRoleCode() || '').trim();
      const ur = (getUserRole() || '').trim();
      const acc = (getAccount() || '').trim().toLowerCase();
      if (rc === 'SYSTEM_ADMIN' || ur === 'SYSTEM_ADMIN') return true;
      if (rc === 'admin' || ur === 'admin') return true;
      if (acc === 'admin') return true;
      return false;
    }
  },
  watch: {
    'addForm.disabled'(val) {
      if (!val) {
        this.addForm.disabledDate = '';
        this.addForm.disabledReason = '';
        this.$nextTick(() => this.$refs.addFormRef && this.$refs.addFormRef.clearValidate(['disabledDate', 'disabledReason']));
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize
        };
        if (this.searchForm.platformName) params.platformName = this.searchForm.platformName;
        if (this.searchForm.username) params.username = this.searchForm.username;
        if (this.searchForm.disabled !== null && this.searchForm.disabled !== undefined && this.searchForm.disabled !== '') {
          params.disabled = this.searchForm.disabled;
        }
        const res = await api.post('/promotion-account/list', params);
        if (!res.data.success) {
          this.tableData = [];
          this.total = 0;
          return;
        }
        const data = res.data.data || {};
        const list = (data.list || []).map(row => ({
          id: row.id,
          username: row.username,
          accountRemark: row.accountRemark || '',
          addDate: row.addDate || '',
          platformName: row.platformName || '',
          authorizationLink: row.authorizationLink || '',
          secretKey: row.secretKey || '',
          disabled: !!row.disabled,
          disabledDate: row.disabledDate || '',
          disabledReason: row.disabledReason || ''
        }));
        // 按平台名称聚合（便于合并「平台名称」列）；同平台内未停用在上、已停用在下，再按 id 稳定排序
        list.sort((a, b) => {
          const pa = a.platformName || '';
          const pb = b.platformName || '';
          if (pa !== pb) return pa.localeCompare(pb, 'zh-CN');
          const da = a.disabled ? 1 : 0;
          const db = b.disabled ? 1 : 0;
          if (da !== db) return da - db;
          return (a.id || 0) - (b.id || 0);
        });
        this.tableData = list;
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error('加载数据失败');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    async handleDetail(row) {
      if (!row.id) return;
      try {
        const res = await api.post(`/promotion-account/${row.id}/authorization-info`, {});
        if (!res.data.success || !res.data.data) {
          this.$message.error('获取授权信息失败');
          return;
        }
        const d = res.data.data;
        this.editingId = row.id;
        this.isEdit = false;
        this.isDetail = true;
        this.detailForm.thirdPartyAuthorizationInfo = d.thirdPartyAuthorizationInfo || '';
        this.addDialogVisible = true;
      } catch (e) {
        this.$message.error(e.response?.data?.message || '获取授权信息失败');
      }
    },
    formatDurationSeconds(value) {
      const totalSeconds = Number(value);
      if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return this.formatAuthorizationValue(value);
      const seconds = Math.floor(totalSeconds);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${days}天${hours}时${minutes}分${secs}秒`;
    },
    formatAuthorizationValue(value) {
      if (value === null || value === undefined) return '';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    },
    async copyAuthorizationValue(value, key) {
      const text = value == null ? '' : String(value);
      if (!text) {
        this.$message.warning('暂无可复制内容');
        return;
      }
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const input = document.createElement('textarea');
          input.value = text;
          input.setAttribute('readonly', 'readonly');
          input.style.position = 'fixed';
          input.style.left = '-9999px';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        this.$message.success(`${key}已复制`);
      } catch (e) {
        this.$message.error('复制失败，请手动复制');
      }
    },
    buildAuthorizationUrl(authorizationLink, id, secretKey) {
      const link = authorizationLink ? String(authorizationLink).trim() : '';
      const recordId = id !== undefined && id !== null ? String(id).trim() : '';
      const recordSecretKey = secretKey ? String(secretKey).trim() : '';
      if (!link) {
        this.$message.warning('请先配置授权链接');
        return '';
      }
      if (!recordId) {
        this.$message.warning('请先保存账户后再授权');
        return '';
      }
      if (!recordSecretKey) {
        this.$message.warning('请先配置secretKey');
        return '';
      }
      const stateValue = `${recordId}&&${recordSecretKey}`;
      const encodedStateValue = encodeURIComponent(stateValue);
      if (/[?&]state=/.test(link)) {
        return link.replace(/([?&]state=)([^&#]*)/, `$1${encodedStateValue}`);
      }
      const hashIndex = link.indexOf('#');
      const linkWithoutHash = hashIndex === -1 ? link : link.slice(0, hashIndex);
      const hash = hashIndex === -1 ? '' : link.slice(hashIndex);
      const separator = linkWithoutHash.includes('?') ? '&' : '?';
      return `${linkWithoutHash}${separator}state=${encodedStateValue}${hash}`;
    },
    openAuthorizationLink(row) {
      const source = row || {
        id: this.editingId,
        authorizationLink: this.addForm.authorizationLink,
        secretKey: this.addForm.secretKey
      };
      const url = this.buildAuthorizationUrl(source.authorizationLink, source.id, source.secretKey);
      if (!url) return;
      const win = window.open(url, '_blank', 'noopener,noreferrer');
      if (win) win.opener = null;
    },
    async handleAuthorize(row) {
      if (!row || !row.id) return;
      if (row.authorizationLink && row.secretKey) {
        this.openAuthorizationLink(row);
        return;
      }
      try {
        const res = await api.post(`/promotion-account/${row.id}`, {});
        if (!res.data.success || !res.data.data) {
          this.$message.error('获取账户详情失败');
          return;
        }
        const d = res.data.data;
        this.openAuthorizationLink({
          id: row.id,
          authorizationLink: d.authorizationLink || '',
          secretKey: d.secretKey || ''
        });
      } catch (e) {
        this.$message.error(e.response?.data?.message || '获取账户详情失败');
      }
    },
    handleDelete(row) {
      if (!row || !row.id) return;
      this.$confirm(`确定删除推广账户「${row.username || row.id}」吗？此操作不可恢复。`, '删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await api.post(`/promotion-account/${row.id}/remove`, {});
            if (res.data && res.data.success) {
              this.$message.success('删除成功');
              this.loadData();
            } else {
              this.$message.error((res.data && res.data.message) || '删除失败');
            }
          } catch (e) {
            this.$message.error(e.response?.data?.message || '删除失败');
          }
        })
        .catch(() => {});
    },
    async handleEdit(row) {
      if (!row.id) return;
      try {
        const res = await api.post(`/promotion-account/${row.id}`, {});
        if (!res.data.success || !res.data.data) {
          this.$message.error('获取账户详情失败');
          return;
        }
        const d = res.data.data;
        this.editingId = row.id;
        this.isEdit = true;
        this.isDetail = false;
        this.addForm = {
          username: d.username || '',
          password: d.password || '',
          token: d.token || '',
          authorizationLink: d.authorizationLink || '',
          accessToken: d.accessToken || '',
          appId: d.appId || '',
          secretKey: d.secretKey || '',
          platformName: d.platformName || '百度',
          entityCompany: d.entityCompany || '',
          disabled: !!d.disabled,
          disabledDate: d.disabledDate ? (d.disabledDate + ' 00:00:00') : '',
          disabledReason: d.disabledReason || '',
          accountRemark: d.accountRemark || ''
        };
        this.addDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
        });
      } catch (e) {
        this.$message.error(e.response?.data?.message || '获取账户详情失败');
      }
    },
    async handleQuery() {
      this.queryLoading = true;
      try {
        await this.loadData();
      } finally {
        this.queryLoading = false;
      }
    },
    handleReset() {
      this.searchForm = {
        platformName: '',
        username: '',
        disabled: null
      };
      this.currentPage = 1;
      this.loadData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    handleAdd() {
      this.isEdit = false;
      this.isDetail = false;
      this.editingId = null;
      this.addForm = {
        username: '',
        password: '',
        token: '',
        authorizationLink: '',
        accessToken: '',
        appId: '',
        secretKey: '',
        platformName: '百度',
        entityCompany: '',
        disabled: false,
        disabledDate: '',
        disabledReason: '',
        accountRemark: ''
      };
      this.addDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
      });
    },
    resetForm() {
      this.addForm = {
        username: '',
        password: '',
        token: '',
        authorizationLink: '',
        accessToken: '',
        appId: '',
        secretKey: '',
        platformName: '百度',
        entityCompany: '',
        disabled: false,
        disabledDate: '',
        disabledReason: '',
        accountRemark: ''
      };
      this.detailForm = {
        thirdPartyAuthorizationInfo: ''
      };
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields();
      this.isEdit = false;
      this.isDetail = false;
      this.editingId = null;
    },
    handleFormSubmit() {
      if (this.isDetail) return;
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return;
        this.addSubmitLoading = true;
        try {
          const payload = {
            username: this.addForm.username,
            token: this.addForm.token,
            authorizationLink: this.addForm.authorizationLink,
            accessToken: this.addForm.accessToken,
            appId: this.addForm.appId,
            secretKey: this.addForm.secretKey,
            platformName: this.addForm.platformName,
            entityCompany: this.addForm.entityCompany,
            accountRemark: this.addForm.accountRemark
          };
          if (this.addForm.password && String(this.addForm.password).trim()) {
            payload.password = this.addForm.password;
          }
          if (this.isEdit) {
            payload.disabled = !!this.addForm.disabled;
            if (this.addForm.disabled) {
              payload.disabledDate = this.addForm.disabledDate ? String(this.addForm.disabledDate).trim().substring(0, 10) : null;
              payload.disabledReason = this.addForm.disabledReason ? String(this.addForm.disabledReason).trim() : null;
            } else {
              payload.disabledDate = null;
              payload.disabledReason = null;
            }
          }
          let res;
          if (this.isEdit && this.editingId) {
            res = await api.post(`/promotion-account/${this.editingId}/update`, payload);
          } else {
            if (!payload.password) {
              this.$message.error('请输入账户密码');
              this.addSubmitLoading = false;
              return;
            }
            payload.password = this.addForm.password;
            res = await api.post('/promotion-account/add', payload);
          }
          if (res.data.success) {
            this.$message.success(this.isEdit ? '更新成功' : '新增成功');
            this.addDialogVisible = false;
            this.loadData();
          } else {
            this.$message.error(res.data.message || (this.isEdit ? '更新失败' : '新增失败'));
          }
        } catch (e) {
          this.$message.error(e.response?.data?.message || (this.isEdit ? '更新失败' : '新增失败'));
        } finally {
          this.addSubmitLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.roi-page {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.filter-bar {
  flex-shrink: 0;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 16px;
}
.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-label {
  width: 80px;
  flex-shrink: 0;
  color: #606266;
  font-size: 14px;
  text-align: right;
}
.filter-select {
  width: 180px;
}
.filter-input {
  width: 200px;
}
.table-card {
  flex: 1;
}
.promotion-account-table {
  margin-top: 0;
}
.authorization-info-kv {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}
.authorization-info-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  border-bottom: 1px solid #ebeef5;
}
.authorization-info-row:last-child {
  border-bottom: none;
}
.authorization-info-key {
  padding: 10px 12px;
  background: #f5f7fa;
  color: #606266;
  font-weight: 600;
  border-right: 1px solid #ebeef5;
  word-break: break-all;
}
.authorization-info-value {
  min-width: 0;
  padding: 8px 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.authorization-info-text {
  flex: 1;
  min-width: 0;
  color: #303133;
  line-height: 24px;
  word-break: break-all;
  white-space: pre-wrap;
}
.authorization-info-empty {
  padding: 12px;
  color: #909399;
  text-align: center;
}
.pagination-wrapper {
  flex-shrink: 0;
  padding: 16px 0;
  display: flex;
  justify-content: center;
}
.danger-text-btn {
  color: #f56c6c;
}
.danger-text-btn:hover {
  color: #f78989;
}
html body .el-dialog .copyright_link_box >>> .el-form-item__content{
  display:flex;
}
</style>
